<div class="card" id="card-config">
  <div class="head">
    <h1>Clientes</h1>
    <div class="row">
      <div class="col-md-5">
        <label class="w-100">Pesquisar:
          <input matInput (keyup)="filtraClientes($event)" autocomplete="off" class="form-control">
        </label>
      </div>
      <div class="col-md-5">
        <label> Status:
          <select mat-select #menuStatusClientes class="form-control" (change)="filtraStatus(menuStatusClientes.value)">
            <option mat-option value="">Todos</option>
            <option mat-option value="1">Ativo</option>
            <option mat-option value="0">Inativo</option>
          </select>
        </label>
      </div>
      <div class="col-md-2 botao-cadastro">
        <button *ngIf="verificarPermissao(['cadastro_cliente'])" class="btn-nav"
          routerLink="../clientes/cadastro"><mat-icon class="material-icons-sharp">
            add_business
          </mat-icon> Novo cliente </button>
      </div>
    </div>
  </div>
  <div class="table-responsive overflow">
    <table mat-table [dataSource]="dataSource" class="table">
      <ng-container matColumnDef="vc_nome">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="vc_nome">Nome</th>
        <td mat-cell *matCellDef="let cliente" class="vc_nome" [class.red]="clienteInativo(cliente)">
          {{ cliente.vc_nome }}
        </td>
      </ng-container>

      <ng-container matColumnDef="vc_cnpj">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="vc_cnpj">CNPJ</th>
        <td mat-cell *matCellDef="let cliente" class="vc_cnpj" [class.red]="clienteInativo(cliente)">
          {{ cliente.vc_cnpj | mask:'00.000.000/0000-00' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="vc_nome_responsavel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="vc_nome_responsavel">Responsavel</th>
        <td mat-cell *matCellDef="let cliente" class="vc_nome_responsavel" [class.red]="clienteInativo(cliente)">
          {{ cliente.vc_nome_responsavel }}
        </td>
      </ng-container>

      <ng-container matColumnDef="vc_email_responsavel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="vc_email_responsavel">Email</th>
        <td mat-cell *matCellDef="let cliente" class="vc_email_responsavel" [class.red]="clienteInativo(cliente)">
          {{ cliente.vc_email_responsavel }}
        </td>
      </ng-container>

      <ng-container matColumnDef="bl_status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="bl_status">Status</th>
        <td mat-cell *matCellDef="let cliente" class="bl_status" [class.red]="clienteInativo(cliente)">
          {{ cliente.bl_status == 1 ? 'Ativo' : 'Inativo' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="acao1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="acao1">Ações</th>
        <ng-container *ngIf="verificarPermissao(['atualizar_cliente'])">
          <td mat-cell *matCellDef="let cliente" class="acao1">
            <button *ngIf="verificarPermissao(['atualizar_cliente'])" class="btn-nav"
              routerLink="../clientes/atualizar/{{cliente.sr_id}}"> <mat-icon class="material-icons-sharp">
                edit
              </mat-icon>Editar</button>
          </td>
        </ng-container>
      </ng-container>
      <ng-container matColumnDef="acao2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="acao2"></th>
        <td mat-cell *matCellDef="let cliente" class="acao2">
          <button (click)="finalizar(cliente)" *ngIf="verificarPermissao(['status_cliente'])" class="btn-nav">
            <mat-icon class="material-icons-sharp del">
              delete_forever
            </mat-icon>Ativa/Desativar</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
    </table>
  </div>
  <mat-paginator fxLayoutAlign="center center" pageSize="15">
  </mat-paginator>
</div>
<div class="load d-flex justify-content-center" *ngIf="load">
  <mat-progress-spinner diameter=30 class="example-margin" [color]="color" [mode]="mode" [value]="value">
  </mat-progress-spinner>
</div>